import { useSearchParams } from "react-router-dom";
import { parseBuildSearch, BuildSearchParams } from "~/components/build/Show/lib/searchParams";

export type { BuildSearchParams };

/**
 * Hook to extract build-page related query parameters from the URL.
 *
 * Returns schema-validated params via `parseBuildSearch`. The returned object
 * uses URL-level key names (jid, sid, open, tab, annotations_tab).
 */
export default function useQueryParams(): BuildSearchParams {
  const [searchParams] = useSearchParams();
  return parseBuildSearch(Object.fromEntries(searchParams.entries()));
}
